import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PaymentMethodPageService } from '../../shared/services';
import { SystemPages } from '../../shared/enums/routerPaths.enum';

export const AddPaymentMethodPageGuard: CanActivateFn = () => {
  const paymentMethodPageService: PaymentMethodPageService = inject(PaymentMethodPageService);
  const router: Router = inject(Router);

  const canBeOpened: boolean = paymentMethodPageService.getBeOpened();

  if (!canBeOpened) {
    void router.navigate([SystemPages.BILLING]);
  }

  return canBeOpened;
};
